module.exports = __webpack_public_path__ + "img/visit-norfolk-logo.df2ea6b9.svg";